/**
 * @generated SignedSource<<7ab98fdd34e79ffc9e4d103fd1c89c6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type BookScrapActionEnum = "book_scrap_delete" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BookBookScrapPaginator_book$data = {
  readonly bookScraps: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly actions: ReadonlyArray<BookScrapActionEnum>;
        readonly id: string;
        readonly problemBookPage: number;
        readonly problemNumber: string;
        readonly solutionBookPage: number | null;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"BookScrapConnectionDataTable_bookScrapConnection">;
  };
  readonly id: string;
  readonly " $fragmentType": "BookBookScrapPaginator_book";
};
export type BookBookScrapPaginator_book$key = {
  readonly " $data"?: BookBookScrapPaginator_book$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookBookScrapPaginator_book">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "bookScraps"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./BookBookScrapPaginatorRefreshQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "BookBookScrapPaginator_book",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "bookScraps",
      "args": null,
      "concreteType": "BookScrapConnection",
      "kind": "LinkedField",
      "name": "__BookBookScrapPaginator_book_bookScraps_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BookScrapEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BookScrap",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "actions",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "problemBookPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "solutionBookPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "problemNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BookScrapConnectionDataTable_bookScrapConnection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Book",
  "abstractKey": null
};
})();

(node as any).hash = "80c62e6fe2be7d213e20b6c485a1ac08";

export default node;
